import { useState } from 'react';

import type { Editable } from './agendaDraft';

interface UseAgendaOpeningStatementParams {
    initialValue: string;
    onSave: (value: string) => void;
    editable: Editable;
}

/** The agenda's opening statement: typed into a form then saved when the form is left, or saved whole. */
export const useAgendaOpeningStatement = ({
    initialValue,
    onSave,
    editable,
}: UseAgendaOpeningStatementParams) => {
    const [value, setValue] = useState(initialValue);
    const [isEditing, setIsEditing] = useState(false);

    return {
        value,
        isEditing,
        startEditing: editable(() => setIsEditing(true)),
        change: editable(setValue),
        finishEditing: editable(() => {
            setIsEditing(false);
            onSave(value);
        }),
        /** For an editor that hands over the finished text in one call: saved as given, never as the
         * state it has not reached yet. */
        save: editable((nextValue: string) => {
            setValue(nextValue);
            onSave(nextValue);
        }),
    };
};
